<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Settings for client
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="ListSetting"
      :options.sync="options"
      :server-items-length="total"
      :loading="tokenLoader"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:item.limit="{ item }"
        ><span v-if="item.limit">{{ item.limit }}</span>
        <span v-else>--</span>
      </template>
      <template v-slot:item.value="{ item }"
        ><span v-if="item.value == 'yes' || item.value == 'no'">{{
          capitalizeFirstLetter(item.value)
        }}</span>
        <span v-else>{{ item.value }}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip class="ma-1" :color="item.status ? 'success' : 'error'">
          {{ item.status ? "Active" : "Inactive" }}
        </v-chip>
      </template>
      <template v-slot:item.client_key_status="{ item }">
        <v-switch
          v-model="item.client_key_status"
          @change="tokenStatusChange(item)"
          v-if="checkPermission('app_client:client_generate_token_toggle')"
        ></v-switch>
        <span v-else>{{ item.client_key_status }}</span>
      </template>
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col
            cols="12"
            md="6"
            class="d-flex flex-column align-left justify-center mt-2 pt-0"
          >
            <v-toolbar-title class="pl-4 text-h6"> Clients </v-toolbar-title>
          </v-col>

          <v-col cols="12" md="6" class="d-flex justify-end pr-4">
            <v-btn
              color="primary"
              dark
              class="mb-2 text-end mr-4"
              small
              v-if="
                checkPermission('app_client:client_settings_list') &&
                $route.params.id &&
                Object.keys(config_value).length > 0
              "
              @click="add()"
              >Settings
            </v-btn>
            <v-select
              label="Client"
              :rules="[(v) => !!v || 'CLient is required.']"
              class="required pt-0 mt-0 pr-4"
              v-model="selectedClient"
              :items="clients"
              hide-no-data
              hide-details
              item-text="name"
              item-value="id"
              outlined
              dense
              @input="clientTypeList()"
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="mt-3"></v-divider>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="650px"
      @keydown.esc="close"
      persistent
    >
      <v-card>
        <v-toolbar flat style="height: 45px">
          <v-toolbar-title>
            <span
              >Settings
              <i class="caption red--text ml-4"> * required field</i></span
            >
          </v-toolbar-title>
        </v-toolbar>
        <v-divider class="mt-3"></v-divider>
        <v-card-text class="mb-0 pb-0">
          <v-container class="pb-0">
            <v-form ref="form">
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  v-for="(options, key) in config_value"
                  :key="key"
                  class="pb-0"
                >
                  <v-select
                    v-if="
                      options[0].required == 'yes' &&
                      key !== 'duty_handling' &&
                      key !== 'service_type'
                    "
                    :label="key.charAt(0).toUpperCase() + key.slice(1)"
                    v-model="selectedValues[key]"
                    :items="options"
                    item-text="text"
                    item-value="value"
                    :rules="
                      options[0].required
                        ? [
                            (v) =>
                              !!v ||
                              `${
                                key.charAt(0).toUpperCase() + key.slice(1)
                              }   is required.`,
                          ]
                        : []
                    "
                    :class="{ required: options[0].required }"
                    outlined
                    class="mr-5 pb-0 mt-0"
                  ></v-select>
                  <v-select
                    v-else-if="key == 'weight'"
                    :label="key.charAt(0).toUpperCase() + key.slice(1)"
                    v-model="selectedValues[key]"
                    :items="options"
                    item-text="text"
                    item-value="value"
                    class="mr-5 pb-0 mt-0"
                    @click="weight = true"
                    outlined
                  ></v-select>
                  <v-select
                    v-else-if="key == 'duty_handling'"
                    :label="key.charAt(0).toUpperCase() + key.slice(1)"
                    v-model="selectedValues[key]"
                    :items="options"
                    item-text="text"
                    item-value="value"
                    :multiple="options[0].select_type == 'multiple'"
                    class="mr-5 pb-0 mt-0 pb-3 required"
                    :rules="[
                      (v) =>
                        (options[0].select_type == 'multiple'
                          ? v.length > 0
                          : v != null && v !== '') ||
                        'Duty Handling is required.',
                    ]"
                    outlined
                  ></v-select>
                  <v-select
                    v-else-if="key == 'service_type'"
                    :label="key.charAt(0).toUpperCase() + key.slice(1)"
                    v-model="selectedValues[key]"
                    :items="options"
                    item-text="text"
                    item-value="value"
                    :multiple="options[0].select_type == 'multiple'"
                    class="mr-5 pb-0 mt-0 pb-3 required"
                    :rules="[
                      (v) =>
                        (options[0].select_type == 'multiple'
                          ? v.length > 0
                          : v != null && v !== '') ||
                        'Service Type is required.',
                    ]"
                    outlined
                  ></v-select>
                  <v-select
                    v-else-if="
                      key !== 'duty_handling' &&
                      key !== 'weight' &&
                      key !== 'service_type'
                    "
                    :label="key.charAt(0).toUpperCase() + key.slice(1)"
                    v-model="selectedValues[key]"
                    :items="options"
                    item-text="text"
                    outlined
                    item-value="value"
                    class="mr-5 pb-0 mt-0"
                  ></v-select>
                </v-col>
              </v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="pl-0"
                v-if="selectedValues.weight == 'yes'"
              >
                <v-text-field
                  v-model="weightLimit"
                  label="Weight Limit"
                  type="number"
                  :rules="[
                    (v) =>
                      (!!v && String(v).indexOf('-') === -1) ||
                      'Please enter Weight Limit in valid format.',
                  ]"
                  class="required"
                  min="0"
                  outlined
                  v-if="weight == true"
                >
                </v-text-field>
              </v-col>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="ml-4 pb-4 pt-0">
          <v-btn color="primary" @click="save" :loading="saveLoader">
            {{ editedIndex === -1 ? "Add" : "Update" }}
          </v-btn>
          <v-btn color="primary" class="error" @click="close"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    weight: false,
    webhook: "",
    headers: [
      {
        text: "Key",
        value: "key",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Value",
        value: "value",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Limit",
        value: "limit",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    editedIndex: -1,
    tokenLoader: false,
    ListSetting: [],
    dialog: false,
    selectedClient: null,
    clients: [],
    config_value: [],
    selectedValues: {},
    duty_handlings: [],
    saveLoader: false,
    total: 0,
    options: {},
    newObject: [],
    service_types: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add new" : "Edit";
    },
  },
  created() {
    this.selectedClient = this.$route.params.id;
    this.clientTypeList();
    this.fetchCLientList();
  },
  methods: {
    ...mapActions([
      "snackBar",
      "generateToken",
      "updateClientSetting",
      "fetchClient",
      "getSettingList",
    ]),

    add() {
      if (this.$route.params.id == undefined) {
        this.snackBar({
          color: "error",
          message: "Client is required",
        });
      } else {
        this.dialog = true;
      }
      let matchingObject = {};
      for (const key in this.newObject) {
        const text1 = this.newObject[key].text;
        const value1 = this.newObject[key].value;

        if (this.config_value[text1]) {
          const configItems = this.config_value[text1];
          const matchingItem = configItems.find(
            (item) => item.value === value1
          );
          if (matchingItem) {
            matchingObject[text1] = matchingItem.value;
          }
          if (text1 == "duty_handling") {
            if (value1 == "ddu,ddp") {
              matchingObject[text1] = ["ddu", "ddp"];
            } else if (value1 == "ddp,ddu") {
              matchingObject[text1] = ["ddu", "ddp"];
            } else if (
              this.config_value.duty_handling[0].select_type == "multiple"
            ) {
              if (value1 == "ddp" || value1 == "ddu") {
                matchingObject[text1] = [value1];
              }
            } else {
              matchingObject[text1] = value1;
            }
          }
          if (text1 == "service_type") {
            matchingObject[text1] = value1.split(",");
          }
        }
      }
      this.selectedValues = matchingObject;
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (Object.keys(this.selectedValues).length == 0) {
        return;
      }
      this.saveLoader = true;
      let data = [];
      for (let key in this.selectedValues) {
        var obj = {};
        if (key == "weight") {
          if (this.selectedValues[key] == "no") {
            this.weightLimit = "";
          }
          obj = {
            key: key,
            value: this.selectedValues[key],
            limit: this.weightLimit,
          };
        } else if (key == "webhook") {
          obj = {
            key: key,
            value: this.selectedValues[key],
          };
        } else if (key == "duty_handling" || key == "service_type") {
          if (typeof this.selectedValues[key] == "object") {
            obj = {
              key: key,
              value: this.selectedValues[key].join(","),
            };
          } else {
            obj = {
              key: key,
              value: this.selectedValues[key],
            };
          }
        } else {
          obj = {
            key: key,
            value: this.selectedValues[key],
          };
        }
        data.push(obj);
      }
      if (this.editedIndex > -1) {
        this.updateClientSetting({
          client_id: this.$route.params.id,
          data: data,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.editedIndex = -1;
            this.editedOMS = {};

            this.fetchList();
          })
          .catch(() => {
            this.dialog = false;
            this.editedIndex = -1;
            this.editedOMS = {};

            this.saveLoader = false;
          });
      } else {
        let payload = {
          client_id: this.$route.params.id,
          data: data,
        };
        this.updateClientSetting(payload)
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.fetchList();
          })
          .catch(() => {
            this.saveLoader = false;
            this.dialog = false;
          });
      }
    },
    fetchCLientList() {
      this.fetchClient().then((res) => {
        this.clients = res.data;
      });
    },
    fetchList() {
      if (this.$route.params.id !== undefined) {
        this.tokenLoader = true;
        this.getSettingList(this.$route.params.id)
          .then((res) => {
            this.tokenLoader = false;
            this.ListSetting = res.data.client_setting;
            this.newObject = [];
            this.ListSetting.forEach((e) => {
              let obj = {
                text: "",
                value: "",
              };

              obj.text = e.key;
              obj.value = e.value;
              if (e.limit !== null) {
                if (e.key == "weight") {
                  this.weightLimit = e.limit;
                  this.weight = true;
                }
              }

              this.newObject.push(obj);
            });
            this.config_value = res.data.config_value;
            this.total = res.data.total;
          })
          .catch(() => {
            this.tokenLoader = false;
          });
      }
    },
    clientTypeList() {
      this.$route.params.id = this.selectedClient;
      this.$router.replace({
        params: {
          id: this.$route.params.id,
        },
      });
      this.fetchList();
    },
  },
};
</script>
